<!-- 百度单元充值统计  -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">百度单元充值统计</div>
		
		
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 5px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			
			<div class="screen-box" >
				<div class="screen-label">投放日期</div>
				<a-date-picker @change="onChangeDate" :locale="locale"  :allowClear="false" :value="this.moment(endTime, dateFormat)" />
				<!-- <a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" /> -->
			</div>
			
			<div class="screen-box" >
				<div class="screen-label">单元ID</div>
				<a-input v-model="r_ad_id" allowClear placeholder="请输入单元ID" style="width: 180px;"/>
			</div>
			
			<div class="screen-box" >
				<div class="screen-label">单元名称</div>
				<a-input v-model="r_plan_name" allowClear placeholder="请输入单元名称" style="width: 180px;"/>
			</div>
			
			<div class="screen-box" >
				<div class="screen-label">账户ID</div>
				<a-input v-model="r_adv_id" allowClear placeholder="请输入账户ID" style="width: 180px;"/>
			</div>
			
			<div class="screen-box" >
				<div class="screen-label">账户名称</div>
				<a-input v-model="r_adv_name" allowClear placeholder="请输入账户名称" style="width: 180px;"/>
			</div>
			
			<!-- <div class="screen-box" >
				<div class="screen-label">推广人员</div>
				<a-select
					mode="multiple" 
					style="width: 200px;"
					placeholder="请选择推广人员"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(value,key) in tgSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
		</div>
	
	</div>
	
	
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
			
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.date_key}}
				</div>
				<!-- 单元名称 -->
				<div class="table-td-cell" :style="{'width': rableTitle[1].width + 'px'}">
					{{item.unit_name}}
				</div>
			</div>
			
			
			<!-- 单元ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
				{{item.unitId}}
			</div>
			<!-- 账户名称 -->
			<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
				{{item.adUcName}}
			</div>
			<!-- 账户ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
				{{item.adv_id}}
			</div>
			<!-- 当天总充值金额 -->
			<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}">
				{{item.sum_order_money}}
			</div>
			<!-- 当天订单笔数 -->
			<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}">
				{{item.count_num}}
			</div>
			<!-- 当天付费人数 -->
			<div class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}">
				{{item.count_pay}}
			</div>
			<!-- 已经回传人数 -->
			<div class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.report_user}}
			</div>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	<!-- 分页 -->
	<!-- <div :style="{'width':table_scroll_width + 'px',}"> -->
		<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;position: sticky;left: 30px;z-index: 5;">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	<!-- </div> -->
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { bdPlanList, marketersDataSelectTg } from '@/request/api'

export default {
	name: 'bdPlan_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			titleTab: [
				{label: "投手明细数据", select: true , value: 1 },
				{label: "投手汇总数据", select: false , value: 2 },
			],
			content_type: 1, // 页面内容展现类型
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				
				{title:"日期",width:90, sort_status:0, type:"date_key", text_right: false,sort_:90,sort_control: false,show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"单元名称",width:180, sort_status:0, type:"unit_name", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"单元ID",width:130, sort_status:0, type:"unitId", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"账户名称",width:150, sort_status:0, type:"adUcName", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"账户ID",width:150, sort_status:0, type:"adv_id", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"当天总充值金额",width:150, sort_status:0, type:"sum_order_money", text_right: false,sort_:36,sort_control: true,show_control: true,},
				{title:"当天订单笔数",width:120, sort_status:0, type:"count_num", text_right: false,sort_:36,sort_control: true,show_control: true,},
				{title:"当天付费人数",width:120, sort_status:0, type:"count_pay", text_right: false,sort_:36,sort_control: true,show_control: true,},
				{title:"已经回传人数",width:120, sort_status:0, type:"report_user", text_right: false,sort_:36,sort_control: true,show_control: true,},
				
			],
			tableShowData: [],
			
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			
			r_page: 1,
			table_total: 0,
			r_limit: 20,
			
			r_ad_id: "", // 计划ID
			r_plan_name: "", // 计划名称
			r_adv_id: "", // 账户ID
			r_adv_name: "", // 账户名称
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			r_user_id: [], // 推广人员
			
			filterData: {
				op_id:{
					list: [{}],
				},
			}, 
			
			
			tgSelect: {}, // 推广人员选择器
		}
	},
	mounted(){
		let that = this
		
		// that.search_button_loading = true
		
		that.body_width = document.body.clientWidth - 100 // 筛选条件大盒子的宽度
		console.log("body_width",that.body_width);
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30
		
		// 获取昨天前日期
		let date1 = new Date(new Date().getTime() - 86400000);
		let same_day1
		if(date1.getDate() < 10){
			same_day1 = "0" + date1.getDate()
		}
		else {
			same_day1 = date1.getDate()
		}
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2; // 默认只获取当天
		
		
		marketersDataSelectTg().then(res=>{
			console.log("获取推广人员",res);
			that.tgSelect = res.data.data.list
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			// this.startTime = dateString[0]
			// this.endTime = dateString[1]
			
			this.endTime = dateString
		},
		
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.searchButton()
			}
			
			
		},
		
		// 请选择投手
		handleChangeA(e){
			console.log(e);
			this.r_user_id = e
		},
		
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				export: 0,
				limit: that.r_limit,
				page: that.r_page,
				
				// start_time: that.startTime.replace(/-/g, ''),
				// end_time: that.endTime.replace(/-/g, ''),
				date_key: that.endTime.replace(/-/g, ''),
				// date_key: 20220224,
				
				ad_id: that.r_ad_id, 
				plan_name: that.r_plan_name,
				adv_id: that.r_adv_id,
				adv_name: that.r_adv_name,
			}
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			bdPlanList(r_data).then(res=>{
				console.log("搜索结果",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
			
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				let v = Number(e.charge_money)/Number(e.cost)
				return v.toFixed(2)
			}
			else {
				return '-'
			}
			
		}
	}
}
</script>

<style scoped>
.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}
	
	

.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}


</style>